module.exports = __webpack_public_path__ + "static/media/Screenshot_20170917-155318-03.f79084dd.jpeg";